import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useState } from "preact/hooks";
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"

const sizeOrder = [
    '0-3', '3-6', '6-12', '12-18', '18-24', 
    '2T', '3T', '4T', 'XS', 'S', 'M', 'L', 
    'XL', 'XXL', 'XXXL', 'OS'
];

const sortSizes = (data) => {
    return data.sort((a, b) => 
        sizeOrder.indexOf(a.value) - sizeOrder.indexOf(b.value)
    );
};

export default function Facet({ facet }) {
    const { active, selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)
    const [interestsFilterAbsentOrActive, setInterestsFilterAbsentOrActive] = useState(true)

    const facetData = facet.name === "Size" ? sortSizes([...facet.data]) : facet.data;

    const closeFacetHandler = () => {
        if(active){
            toggleActive()
        }
    }

    document.addEventListener("click", function(event) { 
        if(!event.target.closest('.ns-sidebar-header.customizer') && window.location.href.includes("/collections/customizer")) {
            closeFacetHandler()
        } 
    });
    
    return (
        <li class={`ns-sidebar-dropdown ns-facet-list-item ${(active && interestsFilterAbsentOrActive) ? "ns-active" : ""}`}>
            <a
                class="ns-facet-container"
                href="javascript:void(0)"
                data-nosto-element="facet"
                onClick={toggleActive}
            >
                <span class="ns-facet-name">{facet.name}</span>
    
                {(active && interestsFilterAbsentOrActive) ?
                    (<span class="ns-facet-icon-minus">
                        <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.615234" y="1.76917" width="1.53846" height="10.7692" transform="rotate(-90 0.615234 1.76917)" fill="#393d3c" />
                        </svg>
                    </span>) : (
                        <span class="ns-facet-icon-plus">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="4.61572" y="10.7692" width="1.53846" height="10.7692" transform="rotate(-90 4.61572 10.7692)" fill="#393d3c" />
                                <rect x="10.769" y="15.3845" width="1.53846" height="10.7692" transform="rotate(180 10.769 15.3845)" fill="#393d3c" />
                            </svg>
                        </span>
                    )}
            </a>
            <div class={(active && interestsFilterAbsentOrActive) ? "ns-sidebar-submenu ns-facet-menu" : "ns-d-none"}>
                {window.location.href.includes("/collections/customizer") && <button class="ns-close-interest-box" onClick={closeFacetHandler}>X</button>}
                <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                    {facetData?.map(value => (
                        <li
                            class="ns-facet-menu-option"
                            data-nosto-element="facet-setting"
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                onChange={e => {
                                    e.preventDefault()                                   
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                            {/* <span class="ns-facet-value-count">
                                ({value.count})                            
                            </span> */}
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}
